import {createPopupCloudHtmlRequester, renderPopupCloudErrorHtml} from "./popup-render-cloud";

function toPositiveInteger(value) {
    return Number.parseInt(value, 10) || 0;
}

function toFirebaseId(value) {
    const normalized = String(value || '').trim().toLowerCase();
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(normalized)
        ? normalized
        : '';
}

export const requestBookingPopupCloudHtml = createPopupCloudHtmlRequester({
    authAction: 'wl_get_booking_popup_cloud_auth',
    storageKey: 'booking_popup',
    label: 'Booking popup',
    buildCloudPayload(data = {}) {
        return {
            post_id: toPositiveInteger(data.post_id),
            timestamp: toPositiveInteger(data.timestamp),
            duration_minutes: Number(data.duration_minutes ?? 30),
            booking_id: toPositiveInteger(data.booking_id),
            firebase_id: toFirebaseId(data.firebase_id),
            user_id: toPositiveInteger(data.user_id),
            status_simply_book: toPositiveInteger(data.status_simply_book),
            service_simply_book: toPositiveInteger(data.service_simply_book),
            available_service_provider: toPositiveInteger(data.available_service_provider || data.service_provider_user),
            booking_user_ids: Array.isArray(data.booking_user_ids) ? data.booking_user_ids : [],
        };
    },
});

const activeBookingPopupRequests = new WeakMap();

export function requestCoordinatedBookingPopupCloudHtml(popupElement, data = {}) {
    if (!popupElement || (typeof popupElement !== 'object' && typeof popupElement !== 'function')) {
        throw new Error('Booking popup target is unavailable.');
    }

    const activeRequest = activeBookingPopupRequests.get(popupElement);
    if (activeRequest) {
        return {promise: activeRequest, started: false};
    }

    let coordinatedRequest;
    coordinatedRequest = requestBookingPopupCloudHtml(data).finally(() => {
        if (activeBookingPopupRequests.get(popupElement) === coordinatedRequest) {
            activeBookingPopupRequests.delete(popupElement);
        }
    });
    activeBookingPopupRequests.set(popupElement, coordinatedRequest);

    return {promise: coordinatedRequest, started: true};
}

export function renderBookingPopupCloudErrorHtml() {
    return renderPopupCloudErrorHtml();
}
